module.exports = __webpack_public_path__ + "static/media/pink-citrus.ec8051fa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/pink-citrus.jpeg
// module id = 2042
// module chunks = 0